// extracted by mini-css-extract-plugin
export default {"loading":"preview_loading__wnNcM","previewWrapper":"preview_previewWrapper__g3X4g","permissionDenied":"preview_permissionDenied__POlsI"};